import React, { useRef, useState, useEffect, useContext } from 'react'
import { GeneralContext } from '../../context/'
import ApiService from '../../data/services/ApiService'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Breadcrumbs from '../../components/Global/Breadcrumbs'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { isEmpty, head } from 'lodash'

import {
    Row,
    Col,
    Card,
    CardTitle,
    CardBody,
    FormGroup,
    Container
} from "reactstrap"

const Index = () => {
    const generalContext = useContext(GeneralContext)
    const { loading, setLoading } = generalContext

    const autosuggestRef = useRef(null)
    const [autosuggest, setAutosuggest] = useState()
    const [aduanas, setAduanas] = useState([])

    useEffect(() => {
        (async () => {
            await fetchAduanas()
        })()

        // eslint-disable-next-line
    }, [])

    const _addItem = async (item) => {
        setAutosuggest([])
        const aduana = head(item)

        try {
            setLoading(true)
            const response = await ApiService.createAduana({
                clave: aduana.clave,
                descripcion: aduana.descripcion
            })

            window.analytics.track('Aduana Agregada')
            toastr.success(response.data.message, '¡Chócalas!')
            fetchAduanas()
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }

        autosuggestRef.current.clear()
    }

    const _deleteItem = async (id) => {
        try {
            setLoading(true)
            const response = await ApiService.deleteAduana(id)

            const filtered = aduanas.filter((v) => v._id !== id)
            setAduanas(filtered)

            window.analytics.track('Aduana Eliminada')
            toastr.success(response.data.message, '¡Chócalas!')
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchAduanas = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getAduanas()
            const { data } = response.data

            setAduanas(data)
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const searchInSAT = async (keyword) => {
        try {
            setLoading(true)
            const response = await ApiService.searchForAduanaInSAT(keyword)
            const { data, success } = response.data

            if (success) {
                if (isEmpty(data)) {
                    autosuggestRef.current.focus()
                }

                setAutosuggest(data)
            }
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            <div id="mainContent" className="page mainContent">
                <Container fluid>
                    <Breadcrumbs
                        title="Configuraciones"
                        breadcrumbItem={`Aduanas`}
                        parentLink={`/configuracion/aduanas`}
                    />

                    <Card>
                        <CardTitle>Selecciona del catalogo maestro las aduanas que vayas a utilizar con mayor frecuencia.</CardTitle>

                        <Row>
                            <Col sm={7}>
                                <FormGroup>
                                    <AsyncTypeahead
                                        filterBy={() => true}
                                        id="aduana"
                                        ref={autosuggestRef}
                                        isLoading={loading}
                                        minLength={1}
                                        labelKey="clave"
                                        onChange={_addItem}
                                        onSearch={searchInSAT}
                                        options={autosuggest}
                                        placeholder="Busca una aduana..."
                                        searchText="Buscando..."
                                        promptText="Buscando..."
                                        useCache={true}
                                        caseSensitive
                                        renderMenuItemChildren={(i) => (
                                            <React.Fragment>
                                                <span>({i.clave}) {i.descripcion}</span>
                                            </React.Fragment>
                                        )}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Card>

                    <Card>
                        <CardTitle>Mis Favoritas</CardTitle>

                        <CardBody>
                            <ul className='unidades_list'>
                                {aduanas && aduanas.map((item, key) => {
                                    return (
                                        <li key={key}>
                                            <span><button className="btn btn-danger" type="button" onClick={() => _deleteItem(item._id)}><i className='mdi mdi-trash-can'></i></button> ({item.clave}) {item.descripcion}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Index
